import styled from 'styled-components';

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const SupportLink = styled.a`
  color: var(--color-fg-weakest);
  text-decoration: underline;
`;

const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Footer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export { ButtonGroup, Footer, SupportLink, TitleWrapper, Wrapper };
